import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSensitivePropertyGroupsByNameSelector } from 'src/selectors/projectSensitivePropertyGroupsByName';

export const projectSensitivePropertyGroupNamesSelector =
  memoizeSelectorFactory((projectId: string) =>
    createSelector(
      projectSensitivePropertyGroupsByNameSelector(projectId),
      (sensitivePropertyGroupsByName) =>
        Object.keys(sensitivePropertyGroupsByName)
    )
  );
